
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soreen",
      function () {
        return require("private-next-pages/soreen.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soreen"])
      });
    }
  